module.exports = __webpack_public_path__ + "img/capitano 5 bagno.e2b43de6.jpeg";